import { RISK_ASSESSMENT } from './riskAssessment.action.ts';

const GET_RISK_ASSESSMENT_APPROVAL = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_APPROVAL`;
const GET_RISK_ASSESSMENT_APPROVAL_HISTORY = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_APPROVAL_HISTORY`;
const GET_RISK_ASSESSMENT_APPROVAL_DOWNLOAD = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_APPROVAL_DOWNLOAD`;

const PATCH_RISK_ASSESSMENT_APPROVAL_SUBMIT = `${RISK_ASSESSMENT}/PATCH_RISK_ASSESSMENT_APPROVAL_SUBMIT`;
const PATCH_RISK_ASSESSMENT_APPROVAL_RETRIEVE = `${RISK_ASSESSMENT}/PATCH_RISK_ASSESSMENT_APPROVAL_RETRIEVE`;
const PATCH_RISK_ASSESSMENT_APPROVAL_DENY = `${RISK_ASSESSMENT}/PATCH_RISK_ASSESSMENT_APPROVAL_DENY`;
const PATCH_RISK_ASSESSMENT_APPROVAL_APPROVE = `${RISK_ASSESSMENT}/PATCH_RISK_ASSESSMENT_APPROVAL_APPROVE`;

export const RaaActions = {
  GET_RISK_ASSESSMENT_APPROVAL,
  GET_RISK_ASSESSMENT_APPROVAL_HISTORY,
  GET_RISK_ASSESSMENT_APPROVAL_DOWNLOAD,
  PATCH_RISK_ASSESSMENT_APPROVAL_SUBMIT,
  PATCH_RISK_ASSESSMENT_APPROVAL_RETRIEVE,
  PATCH_RISK_ASSESSMENT_APPROVAL_DENY,
  PATCH_RISK_ASSESSMENT_APPROVAL_APPROVE
};
